import { useContentInfo, useContentModel } from 'app/content/hooks';
import { get, isEmpty } from 'lodash';

/**
 * Hook to manage Pay in Store messaging content retrieval and caching.
 * This hook should be called at the beginning of any page that will need Pay in Store messages content.
 * Use `usePayInStoreMessageContent` to resolve the appropriate content in the appropriate component on the page.
 */
const usePayInStoreMessaging = () => {
  const { payInStoreMessagesModel: modelName } = useContentInfo();
  useContentModel(modelName);
};

function isValid(content) {
  return !isEmpty(content) && !isEmpty(get(content, 'fields'));
}

/**
 * Monitor the content cache for the Pay in Store Messaging model and return it once it is available.
 */
export function usePayInStoreMessageContent() {
  const { payInStoreMessagesModel: name } = useContentInfo();
  const { content } = useContentModel(name);

  return isValid(content) ? content : {};
}

export default usePayInStoreMessaging;
